import { WebmailProtectionInboxProviders } from '../../../../common/models/security/WebmailProtection.model';

export enum ConnectDestinationDeviceId {
    ALL = 'all',
    MGMT = 'mgmt'
}

/**
 * to be completed
 */
export enum PushWebmailProtectionEventFields {
    SCAN_ACTIVE = 'scan_active'
}

export enum PushEvents {
    SETTINGS_CHANGED = 'settings_changed',
    INBOX_REGISTRATION = 'inbox_registration',
    INBOX_REMOVED = 'inbox_removed',
    INBOX_UPDATED = 'inbox_updated',
    CCP_ACCOUNT_CONNECTED = 'ccp__account_connected',
    CCP_DISCONNECTED_API = 'ccp__disconnected_api',
    CCP_TIMELINE_EVENTS_CHANGED = 'ccp__timeline_events_changed',
    CCP_PINNED_EVENTS_CHANGED = 'ccp__pinned_events_changed',
    CCP_SERVICE_UPDATE = 'ccp__service_updated'
}

export interface ConnectDestinationInterface {
    device_id: ConnectDestinationDeviceId,
    app_id: string
}

export interface ConnectSourceInterface {
    device_id: string,
    app_id: string
}

export interface PushWebmailProtectionEventParamsInterface {
    err: any;
    event_name: PushEvents,
    source: ConnectSourceInterface,
    target: ConnectDestinationInterface,
    timestamp: number,
    event_params: PushWebmailProtectionEventInterface
}

export interface PushWebmailProtectionEventInterface {
    inbox_id: string,
    inbox_provider: WebmailProtectionInboxProviders,
    device_id: string,
    service_id: string,
    fields: string|PushWebmailProtectionEventFields[]
}
